module.exports = __webpack_public_path__ + "static/domain-whois_4-9e28fdc84d2c4f8eb01f6cdf9f9980ec.jpg";